module.exports = __webpack_public_path__ + "site/img/function8.8ef1ab9.png";


//////////////////
// WEBPACK FOOTER
// ./site/function8.png
// module id = 104
// module chunks = 1